import { TaskItem, useStyle } from '@organization/features/dashboard/components'
import {
  Task,
  TaskListWidget,
  TaskTypes
} from '@organization/features/dashboard/types'
import { capitalizer } from '@organization/features/dashboard/utils'
import { Card, Flex, List } from 'antd'

import { ArrowRight, Task as TaskIcon } from 'iconsax-react'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

interface Props {
  instance: TaskListWidget
}

const tabList = Object.values(TaskTypes).map((v) => ({
  key: v,
  tab: capitalizer(v)
}))

export const DashboardTasks = ({ instance }: Props) => {
  const [taskType, setTaskType] = useState(TaskTypes.OPENED)
  const { t } = useTranslation()
  const { styles } = useStyle()

  const dataSource = useMemo((): Task[] => {
    return instance[taskType]
  }, [instance, taskType])

  return (
    <Card
      className={styles.cardTask}
      activeTabKey={taskType}
      tabList={tabList}
      title={
        <Flex align="center" gap={8}>
          <TaskIcon size={18} />

          <div>{instance.title}</div>
        </Flex>
      }
      extra={
        <Link to={instance.redirect_url} target="_blank">
          <Flex align="center" gap={8}>
            {t('common.view_all')}
            <ArrowRight size={16} />
          </Flex>
        </Link>
      }
      onTabChange={(value) => {
        if (value === TaskTypes.OPENED) {
          setTaskType(value)
        }

        if (value === TaskTypes.COMPLETED) {
          setTaskType(value)
        }
      }}
    >
      <List
        itemLayout="horizontal"
        dataSource={dataSource}
        renderItem={(task) => <TaskItem {...task} />}
      />
    </Card>
  )
}
